var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#7A9C49"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59738 5.18317H10.4009C10.4724 5.18317 10.5081 5.21888 10.5081 5.29031V14.7189C10.5081 14.7903 10.4724 14.826 10.4009 14.826H9.59738C9.52595 14.826 9.49023 14.7903 9.49023 14.7189V5.29031C9.49023 5.21888 9.52595 5.18317 9.59738 5.18317Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50167 9.49567H14.5017C14.5731 9.49567 14.6088 9.53138 14.6088 9.60281V10.4064C14.6088 10.4778 14.5731 10.5135 14.5017 10.5135H5.50167C5.43025 10.5135 5.39453 10.4778 5.39453 10.4064V9.60281C5.39453 9.53138 5.43025 9.49567 5.50167 9.49567Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButton);
export default __webpack_public_path__ + "static/media/plusButton.4dc84ad1.svg";
export { ForwardRef as ReactComponent };